import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { addEventListener } from '@ifeng-fe/ui_base';

/**
 * 定义 Subhead 组件
 *
 * 导航栏对当前栏目高亮显示，如果导航栏内不存在栏目的则不做处理
 */
class Subhead extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        // onChange: PropTypes.func,
        channel: PropTypes.array,
        columnId: PropTypes.string,
    };

    state = {
        isOpen: false,
        element: '',
        initChannel: this.initChannel(),
        moreCjannel: this.initMoreChannel(),
        enable: true, // 防止用户连击
    };

    // 点击展开导航文件夹
    handleClickNavFold = () => {
        if (!this.state.enable) {
            return;
        }
        this.setState(
            {
                isOpen: !this.state.isOpen,
            },
            () => {
                // 切换打开状态
                if (this.state.isOpen) {
                    this.fadeIn(this.state.element, 5);
                } else {
                    this.fadeOut(this.state.element, 5);
                }
                // this.props.onChange(this.state.isOpen);
            },
        );
    };

    componentDidMount() {
        if (window) {
            this.setState({
                element: window.document.getElementById('navFold'),
            });
            this.initChannel();

            this.getChannelIndex();

            // 点击其他位置关闭文件夹
            addEventListener(window, 'click', e => {
                e = window.event || e;
                const current = e.target.id;

                if ((current !== 'more' || current !== 'more_icon') && this.state.isOpen) {
                    this.handleClickNavFold();
                }
            });
        }
    }

    // 初始化初始导航栏数据
    indexOfMore = '';
    initChannel() {
        const { content } = this.props;

        content.forEach((item, index) => {
            if (item.children) {
                this.indexOfMore = index;
            }
        });
        const newArr = JSON.parse(JSON.stringify(content));
        const more = newArr[this.indexOfMore];

        newArr.splice(this.indexOfMore, 1);
        newArr.push(more);

        return newArr.slice(0, this.indexOfMore + 1);
    }

    // 初始化导航文件夹数据
    initMoreChannel() {
        const { content } = this.props;

        return content[this.indexOfMore].children;
    }

    // 检查当前栏目是否存在
    checkChannel(arr, title) {
        // console.log(arr, cur);
        let res = {
            has: false,
        };

        arr.forEach(item => {
            if (item.title === title) {
                // console.log(item);
                res = {
                    has: true,
                    item,
                };
            }
        });
        // console.log(res);

        return res;
    }

    // 动态渲染导航栏
    getChannelIndex() {
        const { initChannel, moreCjannel } = this.state;
        const { channel, columnId } = this.props;
        const title = channel[channel.length - 1].title;
        let curindex = initChannel.length - 2; // 当前高亮显示的标签的索引

        console.log(title);

        if (this.checkChannel(initChannel, title).has) {
            console.log('在初始栏里面的栏目');
            curindex = initChannel.indexOf(this.checkChannel(initChannel, title).item);
        }
        // 如果栏目在折叠文件夹里面，则把它拿出来替换初始导航栏的倒数第二个，被替换的栏目放入折叠导航栏的第一个的位置
        if (this.checkChannel(moreCjannel, title).has) {
            console.log('在折叠文件夹里面的栏目');

            const newInitChannel = JSON.parse(JSON.stringify(initChannel));
            const newMoreCjannel = JSON.parse(JSON.stringify(moreCjannel));
            const curItem = this.checkChannel(moreCjannel, title).item;

            newInitChannel.splice(initChannel.length - 2, 1, curItem); // 从初始导航栏拿出倒数第二个，将它替换成当前页对应的
            newMoreCjannel.unshift(initChannel[initChannel.length - 2]); // 把被替换的塞到文件夹第一个的位置
            // console.log(moreCjannel.indexOf(curItem));
            newMoreCjannel.splice(moreCjannel.indexOf(curItem) + 1, 1); // 从文件夹删除当前页对应的

            // console.log(newInitChannel);
            // console.log(newMoreCjannel);
            // 重新渲染导航栏
            this.setState({
                initChannel: newInitChannel,
                moreCjannel: newMoreCjannel,
            });
        }
        // 如果导航栏里面没有的栏目
        if (!this.checkChannel(initChannel, title).has && !this.checkChannel(moreCjannel, title).has) {
            console.log('不在里面的栏目');
            const newChannel = { title, url: `//v.ifeng.com/shanklist/v/${columnId}` };
            const newInitChannel = JSON.parse(JSON.stringify(initChannel));
            const newMoreCjannel = JSON.parse(JSON.stringify(moreCjannel));

            newInitChannel.splice(initChannel.length - 2, 1, newChannel); // 替换
            newMoreCjannel.unshift(initChannel[initChannel.length - 2]); // 插入到文件夹
            // 重新渲染导航栏
            this.setState({
                initChannel: newInitChannel,
                moreCjannel: newMoreCjannel,
            });
        }

        // console.log(curindex);
        this.setState({
            curindex,
        });
    }

    // 淡入
    fadeIn = (element, speed) => {
        this.setState({
            enable: false,
        });
        if (element.style.opacity !== 1) {
            element.style.display = 'block';
            const _speed = speed || 30;
            let num = 0;
            const st = setInterval(() => {
                num++;
                element.style.opacity = num / 10;
                if (num >= 10) {
                    clearInterval(st);
                    this.setState({
                        enable: true,
                    });
                }
            }, _speed);
        }
    };

    // 淡出
    fadeOut = (element, speed) => {
        this.setState({
            enable: false,
        });
        if (element.style.opacity !== 0) {
            const _speed = speed || 30;
            let num = 10;
            const st = setInterval(() => {
                num--;
                element.style.opacity = num / 10;
                if (num <= 0) {
                    clearInterval(st);
                    setTimeout(() => {
                        element.style.display = 'none';
                        this.setState({
                            enable: true,
                        });
                    }, 300);
                }
            }, _speed);

            // console.log(st);
        }
    };
    /**
     * 渲染组件
     */
    render() {
        const { channel } = this.props;
        const { isOpen, curindex, initChannel, moreCjannel } = this.state;
        const nav = (
            <div className={`${styles.navBox} clearfix`}>
                {initChannel
                    ? initChannel.map((item, index) => {
                          if (item.children) {
                              return (
                                  <div
                                      className={`${styles.more} ${isOpen ? styles.more_open : ''}`}
                                      onClick={this.handleClickNavFold}
                                      id="more"
                                      key={index}>
                                      {item.title}
                                      <i
                                          id="more_icon"
                                          className={isOpen ? styles.triangle_up : styles.triangle_down}
                                      />
                                  </div>
                              );
                          } else {
                              return (
                                  <div
                                      className={`${styles.navItem} ${
                                          index === curindex && !isOpen ? styles.current : ''
                                      }`}
                                      key={index}>
                                      <a href={item.url} target="_blank">
                                          {item.title}
                                      </a>
                                  </div>
                              );
                          }
                      })
                    : null}
            </div>
        );

        return (
            <header className={styles.subhead} key="">
                <div className={styles.nav}>
                    {nav}
                    <div className={styles.navFold} id="navFold" style={{ opacity: 0 }}>
                        <div className={styles.navFoldBox}>
                            <ul className={`${styles.navFoldBoxInner} clearfix`}>
                                {moreCjannel
                                    ? moreCjannel.map((item, index) => {
                                          return (
                                              <li key={index}>
                                                  <a href={item.url} target="_blank">
                                                      {item.title}
                                                  </a>
                                              </li>
                                          );
                                      })
                                    : null}
                            </ul>
                        </div>
                    </div>
                </div>
            </header>
        );
    }
}

export default errorBoundary(Subhead);
